import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { t } from "ttag";
import { z } from "zod";

import { Category } from "@/shared/domains";
import { useOnboardingStore } from "../stores";

const formSchema = z.object({
  categoryIds: z
    .array(Category.shape.id)
    .refine((value) => value.some((plan) => plan), {
      error: () => t`Please select at least one plan to continue`,
    }),
});

export const useCategoriesForm = () => {
  const selectedCategories = useOnboardingStore(
    (state) => state.selectedCategories,
  );

  return useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      categoryIds: selectedCategories.map((category) => category.id),
    },
  });
};
